import { toast } from "sonner";
import { interfaceTranslator } from "@/i18n/translate";
import type { Property } from "@/lib/collections/properties";

/**
 * A Preparing property (ADR-0144): its current system still runs it, so the
 * server refuses every operational action. The app says why where the action
 * would be: a lone button answers its tap, a surface holding several (a
 * stay's sheet, the guest composer) shows the reason in their place. A host
 * never fills a form the server would revert, and the device never queues an
 * operational write it could replay after activation.
 */

const PREPARING_TOAST_ID = "property-preparing";

export function isPreparing(property: Pick<Property, "operationalState">) {
  return property.operationalState === "preparing";
}

export function preparingMessage(): string {
  return interfaceTranslator("settings.operationalState")("blocked");
}

/** Answers a tap on an action a Preparing property cannot run. */
export function explainPreparing(): void {
  toast.error(preparingMessage(), { id: PREPARING_TOAST_ID });
}
